import { render, staticRenderFns } from "./Talk.vue?vue&type=template&id=63a79e5f&scoped=true&"
import script from "./Talk.vue?vue&type=script&lang=ts&"
export * from "./Talk.vue?vue&type=script&lang=ts&"
import style0 from "./Talk.vue?vue&type=style&index=0&id=63a79e5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a79e5f",
  null
  
)

export default component.exports